<template>
  <div class="app-sidebar">
    <!-- <p style="color: #fff;">{{defaultActive}}</p> -->
    <!-- <div style="margin-bottom:50px"> -->
    <el-menu ref="meun" @select="selectMenu" :active-text-color="menu.activeTextColor"
      :background-color="menu.backgroundColor" :collapse="isCollapse" :default-active="defaultActive"
      :text-color="menu.textColor" class="el-menu-vertical-demo" style="border-right:none;">
      <!-- 根据路由循环出来的菜单 -->
      <template v-for="(item,index) in routes">
        <!-- 一级菜单 -->
        <!-- <router-link  :key="index" :to="item.path" tag="li"> -->
        <el-menu-item v-if="!item.children.length" :index="item.id" @click="toLink(item.path)">
          <i :class="item.meta.icon" />
          <span slot="title">{{ $t('sideBar.'+item.meta.title) }} </span>
        </el-menu-item>
        <!-- </router-link> -->

        <!-- 二级菜单 -->
        <el-submenu v-else :index="item.id">
          <template slot="title">
            <i :class="item.meta.icon" />
            <span slot="title">{{ $t('sideBar.'+item.meta.title) }} </span>
          </template>
          <!-- <router-link  :key="index" :to="child.path"
              style="background:#1f2d3d;" tag="li"> -->
          <template v-for="(child,index) in item.children">
            <el-menu-item :index="child.subId" @click="toLink(child.path)">
              <!-- <i :class="child.meta.icon" /> -->
              <!-- <span slot="title">{{ child.meta.title }}</span> -->
              <span slot="title">{{ $t('sideBar.'+child.meta.title) }} </span>
            </el-menu-item>
          </template>
          <!-- </router-link> -->
        </el-submenu>
      </template>
    </el-menu>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { listByCompanyParentId, listByCompanyParentId2 } from '@/api/company'
import vPinyin from '@/utils/pinyin-vue.js'
import { arrObjSort } from '@/utils/arrayFun.js'
let isClickNav = false;

export default {
  data () {
    return {
      menu: {
        backgroundColor: '#304156',
        // backgroundColor: styles.sidebarBackgr,
        maxWidth: '210px',
        minWidth: '64px',
        textColor: '#bfcbd9',
        activeTextColor: '#1890ff'
      },
      companyOptions: [],
      menus: [],
      routes: [],
      defaultActive: '1',
      whiteList: ['/', '/login', '/404', '/w/yhub']
    }
  },
  computed: {
    ...mapState(['token', 'company', 'isCollapse']),
    path () {
      return this.$route.path
    }
  },
  watch: {
    path (val) {
      if (isClickNav) return
      console.log('path-watch', val)
      this.routeResolve()
      const arr = val.split('/')
      const obj = this.menus.find(item => item.menuUrl.indexOf(arr[1]) >= 0)
      if (obj) {
        this.defaultActive = obj.menuLongCode
        sessionStorage.setItem('sidebar_index', obj.menuLongCode)
      } else {
        this.defaultActive = sessionStorage.getItem('sidebar_index') || '1'
      }
    }
  },
  mounted () {
    this.getUserInfo()
    this.defaultActive = sessionStorage.getItem('sidebar_index') || '1'
  },
  methods: {
    selectMenu (index) {
      console.log('selectMenu', index)
      isClickNav = true
      setTimeout(() => {
        isClickNav = false
      }, 2000);
      this.defaultActive = index
      sessionStorage.setItem('sidebar_index', index)
    },
    toLink (path) {
      this.$router.push(path)
    },
    // 判断路由权限
    routeResolve () {
      const current = this.$route.path
      if (this.whiteList.includes(current)) {
      
        this.$emit('updated', true)
        return
      }
      const arr = current.split('/')
      if (this.menus.length) {
        const obj = this.menus.find(item => {
          const aa = item.menuUrl.split('/')
          return arr[1] == aa[1]
        })
        if (!obj) {
          // 当前页面无权限访问，请联系管理员
          this.$message({
            showClose: true,
            message: '['+ current +']' + this.$t('workOrder.no_page_view'),
            type: 'error'
          });
          this.$emit('updated', false)
          // const p = this.menus[0] ? this.menus[0].menuUrl : '/'
          this.$router.push('/404')
        }else {
          this.$emit('updated', true)
        }
      }
    },
    getUserInfo () {
      this.$store.dispatch('GetUserInfo').then(res => {
        this.getCompany()
        const menus = res.resultModel.menus || []
        menus.sort((a,b) => a.menuLevel - b.menuLevel)
        console.log('menus:', menus)
        this.menus = menus
        this.routeResolve()
        const routes = []
        menus.forEach(item => {
          if (item.menuLongCode.indexOf('_') < 0) {
            routes.push({
              id: item.menuCode,
              path: item.menuUrl,
              menuLevel: item.menuLevel,
              meta: {
                title: item.menuName,
                icon: item.menuIcon
              },
              children: []
            })
          }
        })
        console.log('routes:', routes)
        
        menus.forEach(item => {
          if (item.menuLongCode.indexOf('_') >= 0) {
            const arr = item.menuLongCode.split('_')
            // console.log(arr[0].replace(/^\s+|\s+$/g, ''))
            const index = routes.findIndex(it => it.id == arr[0].replace(/^\s+|\s+$/g, ''))
            // console.log(index,arr)
            if (index >= 0) {
              routes[index].children.push({
                id: item.menuCode,
                subId: item.menuLongCode,
                path: item.menuUrl,
                meta: {
                  title: item.menuName,
                  icon: item.menuIcon
                }
              })
            }

          }
        })
        console.log('导航目录数据：', routes)
        this.routes = routes
      })
    },
    getCompany () {
      console.log('this.$store.state', this.$store.state)
      listByCompanyParentId2({ companyParentId: this.company.id }).then(res => {
        if (res.resultCode == 1001) {
          let arr = [res.resultModel] || []
          arr = this.arrFn(arr)
          // this.setCompanyTreeOption(arr)
          this.$store.dispatch('setCompanyTreeOption', arr)
          // console.log('树状结构公司：', arr, this.$store)
        }
      })
      listByCompanyParentId({ companyParentId: this.company.id }).then((response) => {
        if (response.resultCode == 1001) {
          this.companyOptions = []
          response.resultModel.forEach((v) => {
            if (v.companyName) {
              this.companyOptions.push({
                companyName: v.companyName,
                companyId: v.id
              })
            }
          })
          this.companyOptionsFun()
        }
      })
      console.log('this.companyOptions', this.companyOptions)
    },
    companyOptionsFun () {
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))
      // 将归属公司转拼音进行排序
      this.companyOptions.forEach((v) => {
        if (v.companyName[0] >= 'a' && v.companyName[0] <= 'z') {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName.toUpperCase())
        } else {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName)
        }
      })
      this.companyOptions.sort(arrObjSort('namePinyin'))
      var hadSelfCompany = false // 是否包含自己所在公司。因为受域名限制，可能不展示自己所在公司
      // 排序后，自己公司可能不在首位，所以先删除，再添加
      this.companyOptions.forEach((v, i) => {
        if (v.companyId == sessionCompany.id) {
          hadSelfCompany = true
          this.companyOptions.splice(i, 1)
        }
      })
      if (hadSelfCompany) {
        this.companyOptions.unshift({
          companyName: sessionCompany.companyName,
          companyId: sessionCompany.id
        })
      }
      this.$store.dispatch('setCompanyOption', this.companyOptions)
    },
    arrFn (arr) { // 树状结构中，当子级为空时，删除
      var newArr = []
      arr.forEach(v => {
        if (v.childList.length) {
          var ower = JSON.parse(JSON.stringify(v))
          ower.childList = []
          ower.id = 'ID' + ower.id// 当A公司有子级司时，无法选中A公司，所以将A公司也加入子级中，且将id改为'ID'+id
          v.childList.unshift(ower)// 当A公司有子级司时，无法选中A公司，所以将A公司也加入子级中，且将id改为'ID'+id
          // v.companyName=v.companyName+'/'+v.id   //假数据--方便校验
          newArr.push(v)
          this.arrFn(v.childList)
        } else {
          delete v.childList
          // v.companyName=v.companyName+'/'+v.id   //假数据--方便校验
          newArr.push(v)
        }
      })
      return newArr
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.el-submenu .el-menu-item {
  background-color: #1f2d3d !important;
}
.el-submenu .el-menu-item:hover {
  background-color: #001528 !important;
}
.app-sidebar {
  // background: $menuBg;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  .subMenuContent {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .logo {
    height: $header-height;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: #fff;
    transition: all 0.5s ease-in-out;
    // background-color: #122150;
    transition: all 0.3s linear;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    img {
      width: 110px;
      // width: 100%;
      height: 100%;
      transition: all 0.3s linear;
    }
  }

  .mobile-logo {
    height: $header-height;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #122150;
    transition: all 0.3s linear;

    img {
      width: 40px;
      height: 40px;
      transition: all 0.3s linear;
    }
  }

  .imgIcon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
    margin-left: 5px;
    display: inline-block;
    transform: translateY(21px);
  }

  .iconfont {
    margin-right: 10px;
    margin-left: 5px;
    //   color: $submenu-title;
    //   height: $menuItem-height;
  }

  .search-display {
    position: relative;
    width: 80%;
    margin: 0 auto;
    height: 36px;
    border-bottom: 1px rgb(185, 190, 195) solid;
    cursor: pointer;

    .el-icon-search {
      position: absolute;
      left: 1px;
      top: 10px;
      color: rgb(185, 190, 195);
    }
  }

  .search {
    // margin-top: 20px;
    width: 80%;
  }
}
</style>
